import { apiFetch } from "../../toolympus/api/core";
import { useCrudItem } from "../../toolympus/api/useSimpleCrud"
import { useLocalizedRecord } from "../../toolympus/components/LocalizedRecords";
import { useSingleSchema } from "../../toolympus/hooks/useSchema";
import { Person, PersonApiPath } from "./usePersonList"


export const usePersonEdit = (id: string | number) => {
    const data = useCrudItem<Person>(`${PersonApiPath}/${id}`, {
        defaultValue: {} as Person,
        returnPath: "/person",
    });

    const copyItem = () => {
        return apiFetch<Person>(
            `${PersonApiPath}`,
            "post",
            {
                name: `${data.data.name} (copy)`,
                description: data.data.description,
                description_brief: data.data.description_brief,
                photo_url: data.data.photo_url,
                translations: data.data.translations,
            });
    }

    const { schema } = useSingleSchema(`${PersonApiPath}/uiconfig`);

    const localized = useLocalizedRecord(data.data, {
        defaultLocale: "ru",
        translatedFields: [
            "name",
            "description",
            "description_brief",
        ],
        translationsField: "translations",
        updateItem: (o,c) => data.update(c),
    });

    const { locale, setLocale } = localized;

    return {
        ...data,
        data: localized.item,
        update: (c: Partial<Person>) => localized.updateItem(localized.item, c),
        schema,
        copyItem,
        locale,
        setLocale,
    }
}
